module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAABEklEQVQ4T6WTP0/CUBTFz2VhRcvoQhtXJxYTBxjxAxg/gZOuJrQDZWgjrk6MzOwyOsrgR9BKYkJilIbJxOUd81DJS3kNtb7x5tzfPffPE/zziS2/7vmnJC4AHAB4hXBCVK7Tp+glq98AOI3gHMIbEPcimEKwR/IQxFv1s3o0n4cfJmQT4AYPWrBIouavsO4FZySHpJykz9F4C8AngTBN4r4pdFx73OKgJGDX9Xu6ogChdmAZ1jqulBotZ1ezH/23VFssulGzxXULOYAlgFoWXBTwuEji/R3P71SIWxNSCCDA5D2Jjx2vewnK4M+A1YCUalOkB5FWKYC2KmSrNCBvK/YZNLp32Uq5AOOkrb+x6D1o3Rc76pIRH1eWpwAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/lockjournal.png
// module id = DVFu
// module chunks = 18